<template>
    <v-form :ref="get_step_string">
        <div class="row">
            <div class="col-6 py-0">
                <div id="partnerFields">
                    <div class="form-group row p-md-2" v-if="partner.id > 0" v-for="(input, index) in partner.inputs">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-1 mt-6">
                                    <Tooltip :text="input.description"></Tooltip>
                                </div>
                                <div class="col-md-10" v-if="input.type === 'file'">
                                    <v-file-input
                                        show-size
                                        accept="application/json"
                                        v-model="audience_credentials"
                                        truncate-length="15"
                                        :label="input.name"
                                        :placeholder="input.placeholder"
                                        :rules="[input.is_required === '1' ? requiredFileField : true]"
                                    ></v-file-input>
                                </div><!--col-->
                                <div class="col-md-10" v-else>
                                    <v-text-field
                                        :key="index"
                                        v-model="audience_inputs[index]"
                                        :label="input.name"
                                        :placeholder="input.placeholder"
                                        :rules="[input.is_required === '1' ? requiredField : true, input.validation ? fieldRegexValidation(input.validation, index, 'audience') : true]"
                                    ></v-text-field>
                                </div><!--col-->
                            </div>
                        </div>
                    </div><!--form-group-->

                    <div class="form-group row p-md-2">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-1 mt-6">
                                    <Tooltip text="You can export EID (Encrypted Identifiers) or MAID (Mobile Advertising ID) <br> based on the chosen pricing model"></Tooltip>
                                </div>
                                <div class="col-md-10">
                                    <v-select
                                        :items="$store.getters['ActivateAudienceStore/getPricingModels']"
                                        v-model="pricing_model"
                                        label="Pricing Models"
                                        :rules="[requiredPricingModel]"
                                    ></v-select>
                                </div><!--col-->
                            </div>
                        </div>
                    </div><!--form-group-->

                    <div class="form-group row p-md-2" v-if="!$store.getters['ActivateAudienceStore/getActivationAnalyses'].includes('anonymized')">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-1 mt-6">
                                    <Tooltip text="You can choose the exported files compression type"></Tooltip>
                                </div>
                                <div class="col-md-10">
                                    <v-select
                                        :items="partner.compression_types"
                                        v-model="compression_type"
                                        label="Compression Type"
                                        :rules="[requiredField]"
                                    ></v-select>
                                </div><!--col-->
                            </div>
                        </div>
                    </div><!--form-group-->
                </div>
            </div>
            <div class="col-6 py-0 d-flex justify-content-center align-items-center">
                <div class="text-center">
                    <div>
                        <h3>{{ partner.description }}</h3>
                        <span v-if="partner" v-html="partner.info"></span>
                    </div>
                    <img class="" width="300" height="auto" :src="'/img/assets/endpoints/' + partner.logo" :alt="partner.description">
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>

import validation_rules from "../../../../mixin/validation_rules";
import Tooltip from "../../../../../shared/components/Tooltip.vue";

export default {
    name: "ActivationProperties",
    components: {Tooltip},
    props: {
        isScheduler: Boolean,
        step: Number
    },
    mixins: [validation_rules],
    data: () => ({
        audience_credentials: null,
        audience_inputs: [],
    }),
    methods: {
        async loadJsonFile (file) {
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader()
                fileReader.onload = event => resolve(JSON.parse(event.target.result))
                fileReader.onerror = error => reject(error)
                fileReader.readAsText(file)
            })
        },
        fieldRegexValidation(regexString, index, section, data_stream = null) {
            let fieldValue = undefined
            if (section === 'audience') {
                fieldValue = this.$store.getters['ActivateAudienceStore/getAudienceInputByIndex'](index)
            } else if (section === 'data_stream') {
                fieldValue = this.$store.getters['ActivateAudienceStore/getDataStreamInputByIndex']({
                    index: index,
                    data_stream: data_stream
                })
            } else {
                return true
            }

            let regex = new RegExp(regexString)
            if (fieldValue === undefined) {
                return true
            } else {
                return regex.test(fieldValue) || 'Invalid format'
            }
        },
        validateForm() {
            let current_step = this.step
            if (this.$refs['step_' + current_step].validate()) {
                if (this.isScheduler) {
                    if (this.$store.getters['ActivateAudienceStore/getActivationAnalyses'].includes(this.analyses.types.anonymized.toLowerCase())) {
                        return true
                    } else {
                        this.$store.dispatch('CreateAudienceStore/increaseSchedulerProcessStep')
                    }
                } else {
                    this.$store.dispatch('ActivateAudienceStore/increaseProcessStep')
                }
            }
        }
    },
    created() {
        //
    },
    mounted() {
        if (this.$store.getters['ActivateAudienceStore/getStepStatus']) {
            this.$store.dispatch('ActivateAudienceStore/getEndpointPricingModels')
        }

        if (this.$store.getters['ActivateAudienceStore/getAudienceInputs'].length) {
            this.audience_inputs = this.$store.getters['ActivateAudienceStore/getAudienceInputs']
        }
    },
    computed: {
        partner: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getActivationPartner']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_ACTIVATION_PARTNER', value)
            }
        },
        pricing_model: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getPricingModel']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_PRICING_MODEL', value)

                let selected_pricing_model = this.$store.getters['ActivateAudienceStore/getPricingModelsData'].filter(pricing_model => pricing_model.id === value)
                this.$store.commit('ActivateAudienceStore/SET_PRICE', selected_pricing_model[0].price)
            }
        },
        compression_type: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getAudienceCompressionType']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_AUDIENCE_COMPRESSION_TYPE', value)
            }
        },
        get_step_string() {
            return "step_" + this.step
        }
    },
    watch: {
        audience_inputs: function () {
            let inputs = []
            if (this.audience_inputs) {
                inputs = this.audience_inputs
            }

            this.$store.commit('ActivateAudienceStore/SET_AUDIENCE_INPUTS', inputs)
        },
        audience_credentials: function () {
            if (this.audience_credentials) {
                if (this.audience_credentials.type === "application/json") {
                    let tmp_credentials = this.loadJsonFile(this.audience_credentials)
                    tmp_credentials.then(credentials => {
                        this.$store.commit('ActivateAudienceStore/SET_AUDIENCE_JSON_SERVICE_ACCOUNT', credentials)
                    })
                    this.$store.commit('ActivateAudienceStore/SET_AUDIENCE_SERVICE_ACCOUNT_FILE', this.audience_credentials)
                } else {
                    this.$toast.open({
                        message: 'Invalid JSON format. Please fix it and re-upload it.',
                        type: "error",
                    })
                }
            }
        }
    }
}
</script>

<style scoped>

</style>